/* Advertise the complete catalogue; compatibility remains factual product metadata. */
(() => {
  let ranks = new Map(), owned = new Set();
  function recentRelease(value, today) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const released = new Date(`${value}T00:00:00Z`);
    if (!Number.isFinite(released.getTime()) || released.toISOString().slice(0, 10) !== value) return false;
    const current = new Date(`${today}T00:00:00Z`);
    if (!Number.isFinite(current.getTime())) return false;
    const cutoff = new Date(Date.UTC(current.getUTCFullYear(), current.getUTCMonth() - 6, 1));
    const lastDay = new Date(Date.UTC(cutoff.getUTCFullYear(), cutoff.getUTCMonth() + 1, 0)).getUTCDate();
    cutoff.setUTCDate(Math.min(current.getUTCDate(), lastDay));
    return released >= cutoff && released <= current;
  }
  function initialise() {
    for (const section of document.querySelectorAll('[data-sf-merch]')) {
      const limit = Number(section.dataset.sfLimit);
      const cards = [...section.querySelectorAll('.sf-store-product')];
      const popular = section.dataset.sfMerchMode === 'popular';
      const today = section.dataset.sfToday || new Date().toISOString().slice(0, 10);
      const maxRank = Number(section.dataset.sfMaxRank) || 20;
      if (section.dataset.sfMerchMode === 'latest') {
        cards.sort((a,b) => (b.dataset.sfReleasedOn || '').localeCompare(a.dataset.sfReleasedOn || ''));
      } else if (section.dataset.sfMerchMode === 'popular' && ranks.size) {
        cards.sort((a,b) => (ranks.get(a.dataset.sfProductHandle) || Infinity) - (ranks.get(b.dataset.sfProductHandle) || Infinity));
      }
      let displayed = 0;
      for (const card of cards) {
        const rank = ranks.get(card.dataset?.sfProductHandle);
        const eligible = !owned.has(card.dataset?.sfProductId) && (!popular || (
          Number.isInteger(rank) && rank <= maxRank && recentRelease(card.dataset.sfReleasedOn, today)
        ));
        card.hidden = !eligible || displayed >= limit;
        if (eligible) displayed++;
        if (section.dataset.sfMerchMode === 'latest' || (section.dataset.sfMerchMode === 'popular' && ranks.size)) card.parentElement.append(card);
      }
      if (section.dataset.sfMerchMode === 'related' || popular) section.hidden = displayed === 0;
    }
  }
  function applyRanking(products) {
    const next = new Map((Array.isArray(products) ? products : []).filter(product => product && typeof product.handle === 'string' && Number.isInteger(product.rank) && product.rank > 0).map(product => [product.handle, product.rank]));
    if (!next.size) return;
    ranks = next;
    initialise();
  }
  document.addEventListener('sofly:store-ranking', event => applyRanking(event.detail));
  document.addEventListener('sofly:account-state', event => { owned = new Set(event.detail.excludedProductIds || event.detail.ownedProductIds || []); initialise(); });
  initialise();
  // Public Shopify order also works when Accounts is unavailable or still connecting.
  const rankingUrl = document.querySelector('[data-sf-ranking-url]')?.dataset?.sfRankingUrl;
  if (rankingUrl) {
    fetch(rankingUrl, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) })
      .then(response => { if (!response.ok) throw new Error('Ranking unavailable'); return response.text(); })
      .then(html => {
        const data = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sf-sales-ranking]');
        if (data) applyRanking(JSON.parse(data.textContent));
      })
      .catch(() => { /* Keep the section hidden until a verified ranking is available. */ });
  }
  // Product variant forms are replaced by Dawn. Capture-phase validation runs
  // before its AJAX cart handler, including sticky buttons that submit this form.
  const product = document.querySelector('product-info[data-sf-require-choice="true"]');
  if (product) {
    const required = new Set([...product.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown')].map(el => el.id || el.querySelector('input,select')?.name).filter(Boolean));
    const chosen = new Set();
    const message = document.createElement('p'); message.className = 'sf-store-choice-note';
    message.setAttribute('role', 'status'); message.textContent = 'Choose each product option before adding to cart.';
    product.querySelector('variant-selects')?.before(message);
    const confirm = document.createElement('button'); confirm.type = 'button'; confirm.className = 'button button--secondary';
    confirm.dataset.bladeComponent = 'sf-button-secondary'; confirm.dataset.bladeRevision = '1.6';
    confirm.textContent = 'Confirm selected options';
    message.after(confirm);
    confirm.addEventListener('click', () => { required.forEach(name => chosen.add(name)); message.hidden = true; confirm.hidden = true; });
    product.addEventListener('change', event => {
      const group = event.target.closest('variant-selects fieldset, variant-selects .product-form__input--dropdown');
      if (group) chosen.add(group.id || group.querySelector('input,select')?.name);
      message.hidden = required.size > 0 && [...required].every(name => chosen.has(name));
      confirm.hidden = message.hidden;
    });
    product.addEventListener('submit', event => {
      if (!event.target.matches('form[data-type="add-to-cart-form"]') || (required.size > 0 && [...required].every(name => chosen.has(name)))) return;
      event.preventDefault(); event.stopImmediatePropagation(); message.hidden = false;
      product.querySelector('variant-selects input,variant-selects select')?.focus();
    }, true);
  }
  document.addEventListener('shopify:section:load', initialise);
})();
